import { Application, Controller } from "stimulus"

export default class AddPlaceSuggestedPlacesController extends Controller {
  
  static targets = ["suggestedPlace", "breadcrumbPlace"]

  suggestedPlacesObserver = this.suggestedPlacesObserver();
  onTopPage = window.scrollY < 500;

  connect() {
    this.onTopPage ? this.suggestedPlacesObserver.observe(this.breadcrumbPlaceTarget) : this.appendSuggestedPlacesImages();
  }

  suggestedPlacesObserver() {
    return new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0.2) {
          this.appendSuggestedPlacesImages();
          this.suggestedPlacesObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.25 });
  }

  appendSuggestedPlacesImages() {
    this.suggestedPlaceTargets.forEach(suggestedPlace => {
      const imgStyleUrl = `url(${suggestedPlace.dataset.addPlaceSuggestedPlacesImageUrl})`
      suggestedPlace.style.backgroundImage = imgStyleUrl;
    });
  }

}

const application = Application.start()
application.register("add-place-suggested-places", AddPlaceSuggestedPlacesController)
